import React, { useState } from "react";
import { Grid, Typography, Button, TextField, IconButton, Paper } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth.js';
import { useNotification } from "../../components/NotificationContext";
import { addCategory } from '../../services/categoryService';

const CategoryAdd = () => {
    useAuth();
    const showNotification = useNotification();
    const navigate = useNavigate();
    const [mainCategory, setMainCategory] = useState("");
    const [subCategories, setSubCategories] = useState([""]);
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('token');
    const handleAddSubCategory = () => {
        setSubCategories([...subCategories, ""]);
    };
// Tüm subcategory'lerin boş olup olmadığını kontrol eden fonksiyon
const hasEmptySubCategories = subCategories.some(sub => !sub.trim());
// En az bir dolu subcategory olup olmadığını kontrol eden fonksiyon
const hasValidSubCategory = subCategories.some(sub => sub.trim());
    const handleSubCategoryChange = (index, value) => {
        const newSubCategories = [...subCategories];
        newSubCategories[index] = value;
        setSubCategories(newSubCategories);
    };

    const handleRemoveSubCategory = (index) => {
        if (subCategories.length > 1) {
            const newSubCategories = subCategories.filter((_, i) => i !== index);
            setSubCategories(newSubCategories);
        }
    };

    const handleAddCategory = async () => {
        if (mainCategory.trim()) {
          setLoading(true); // Yükleniyor durumunu başlat
    
          try {
             await addCategory(mainCategory, subCategories.filter(sub => sub.trim()), token);
            showNotification('Kategori başarıyla eklendi!', 'success');
            localStorage.setItem('notificationSeverity', 'success');
    
            // İşlem sonrası formu sıfırla
            setMainCategory("");
            setSubCategories([""]);
            setLoading(false);
            navigate("/admin"); // Başarılı işlem sonrası yönlendirme
          } catch (error) {
            showNotification('kategori Ekleme Başarısız!', 'error');
            setLoading(false);
          }
        }
      };
    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <Grid container justifyContent="center" alignItems="center">
            <Grid size={{ xs: 12, sm: 10,md:10 }} >
                <Paper elevation={5} style={{ padding: '30px', borderRadius: '15px', backgroundColor: '#ffffff' }}>
                    <IconButton onClick={handleBackClick} style={{ marginRight: '10px' }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h4" gutterBottom align="center" style={{ fontWeight: 600, color: '#3f51b5' }}>
                        Kategori Ekle
                    </Typography>

                    {/* Ana Kategori Ekleme */}
                    <TextField
                        label="Ana Kategori Adı"
                        variant="outlined"
                        fullWidth
                        value={mainCategory}
                        onChange={(e) => setMainCategory(e.target.value)}
                        style={{ marginBottom: '20px' }}
                    />

                    {/* Alt Kategoriler */}
                    <Typography variant="h6" style={{ marginBottom: '10px' }}>
                        Alt Kategoriler
                    </Typography>

                    {subCategories.map((subCategory, index) => (
                        <Grid container spacing={2} alignItems="center" key={index} style={{ marginBottom: '10px' }}>
                            <Grid  size={11}>
                                <TextField
                                    label={`Alt Kategori ${index + 1}`}
                                    variant="outlined"
                                    fullWidth
                                    value={subCategory}
                                    onChange={(e) => handleSubCategoryChange(index, e.target.value)}
                                />
                            </Grid>
                            <Grid  size={1}>
                                {subCategories.length > 1 && (
                                    <IconButton 
                                        onClick={() => handleRemoveSubCategory(index)}
                                        color="error"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                )}
                            </Grid>
                        </Grid>
                    ))}

                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleAddSubCategory}
                        style={{ marginBottom: '20px' }}
                    >
                        Alt Kategori Ekle
                    </Button>

                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={loading || !mainCategory.trim() || hasEmptySubCategories || !hasValidSubCategory}
                        onClick={handleAddCategory}
                        style={{
                            padding: '12px',
                            fontWeight: 600,
                            transition: 'background-color 0.3s',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#303f9f')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#3f51b5')}
                    >
                        {loading ? "Ekleniyor..." : "Kategorileri Kaydet"}
                    </Button>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default CategoryAdd;